import type { MessageCatalog } from './types';

const uz: MessageCatalog = {
  nav: {
    home: 'FalaRus',
    games: "O'yinlar",
    partner: 'Suhbat',
    teachers: "O'qituvchilar",
    stats: 'Statistika',
    profile: 'Profil',
  },
  common: {
    user: 'Foydalanuvchi',
    save: 'Saqlash',
    cancel: 'Bekor',
    back: 'Orqaga',
    loading: 'Yuklanmoqda...',
    loadError: 'Yuklashda xato',
    retry: 'Qaytadan urinish',
    today: 'Bugun',
    close: 'Yopish',
    copy: 'Nusxalash',
    copied: 'Nusxalandi',
    share: 'Ulashish',
    saving: 'Saqlanmoqda...',
    finish: 'Yakunlash',
    start: 'Boshlash',
    send: 'Yuborish',
    unknown: "Noma'lum",
    pageNotFound: 'Sahifa topilmadi.',
    noData: "Ma'lumot yo'q.",
  },
  language: {
    selectTitle: 'Tilni tanlang',
    selectSubtitle: 'Interfeys tilini tanlang',
  },
  install: {
    cardTitle: 'Ilovani bosh ekranga chiqaring',
    cardSubtitle: 'Brauzersiz, bir bosishda oching',
    action: 'Chiqarish',
    dismiss: 'Keyinroq',
    profileRow: 'Bosh ekranga chiqarish',
    guideTitle: 'Bosh ekranga chiqarish',
    guideIosIntro: 'iPhone’da buni Safari orqali qo‘shasiz:',
    guideIosStep1: 'Pastdagi «Ulashish» tugmasini bosing (yuqoriga strelkali kvadrat).',
    guideIosStep2: 'Ro‘yxatni pastga suring va «Bosh ekranga qo‘shish»ni tanlang.',
    guideIosStep3: 'O‘ng yuqoridagi «Qo‘shish»ni bosing — ilova bosh ekranda paydo bo‘ladi.',
    guideAndroidIntro: 'Brauzer menyusi orqali qo‘shasiz:',
    guideAndroidStep1: 'O‘ng yuqoridagi menyuni (⋮) bosing.',
    guideAndroidStep2: '«Ilovani o‘rnatish» yoki «Bosh ekranga qo‘shish»ni tanlang.',
    guideAndroidStep3: 'Tasdiqlang — ilova bosh ekranda paydo bo‘ladi.',
    guideDesktopIntro: 'Kompyuterda manzil qatoridan o‘rnatasiz:',
    guideDesktopStep1: 'Manzil qatorining o‘ng chekkasidagi o‘rnatish belgisini bosing.',
    guideDesktopStep2: '«O‘rnatish»ni tasdiqlang.',
    installed: 'Ilova o‘rnatildi!',
    dismissedHint: 'Bekor qildingiz. Xohlagan vaqtda qayta urinib ko‘rishingiz mumkin.',
    close: 'Yopish',
  },
  home: {
    premium: 'Premium',
    patentTitle: 'Patent',
    patentSubtitle: 'Patentga tayyorgarlik',
    vnzhTitle: 'ВНЖ',
    vnzhSubtitle: 'ВНЖga tayyorgarlik',
    questGrammar: 'Grammatika',
    questGrammarSub: "Qoidalarni o'rganish",
    questVocab: "Lug'at",
    questVocabSub: "Yangi so'zlar",
    questReading: "O'qish",
    questReadingSub: 'Matnni tushunish',
    questSpeaking: 'Gapirish',
    questSpeakingSub: 'Suhbat mashqi',
    questSuhbat: 'Savol-javob',
    questSuhbatSub: "Ustoz bilan suhbat",
    questStart: 'Boshlash',
    questRepeat: 'Takrorlash',
    dayLabel: 'Kun {{day}}',
    stepLabel: 'Qadam {{current}} / {{total}}',
    minutesLabel: '~{{minutes}} daqiqa',
    prevDay: 'Oldingi kun',
    nextDay: 'Keyingi kun',
  },
  stats: {
    title: 'Statistika',
    calendarTitle: 'Faollik taqvimi',
    calendarPrevMonth: 'Oldingi oy',
    calendarNextMonth: 'Keyingi oy',
    kunlikGrammar: 'Grammatika (ПЗЗ)',
    kunlikVocab: "Lug'at",
    kunlikReading: "O'qish",
    kunlikSpeaking: 'Gapirish',
    kunlikSuhbat: 'Savol-javob',
    kunlikNone: 'Hali boshlanmagan',
    kunlikContinue: 'Davom etish',
    kunlikStart: 'Boshlash',
    kunlikPrevDaysSingle: '{{day}}-kun yakunlandi',
    kunlikPrevDaysRange: '{{from}}–{{to}}-kunlar yakunlandi',
    kunlikGrammarFmt: '{{done}}/{{total}} mashq',
    kunlikVocabFmt: '{{done}}/{{total}} bosqich',
    kunlikReadingDone: 'Bajarildi',
    kunlikReadingTodo: 'Qilinmagan',
    kunlikSpeakingFmt: '{{done}}/{{total}} topshiriq',
    kunlikSpeakingNoTasks: 'Bu kun uchun topshiriq yo‘q',
    kunlikReadingNoContent: 'Bu kun uchun o‘qish materiallari yo‘q',
    kunlikOpenPlan: 'Kunlik rejaga o‘tish',
  },
  partner: {
    title: 'Suhbat',
    guestTitle: 'Suhbat va sheriklar',
    guestSubtitle: 'Chatlar, guruh va sherik topish uchun kiring',
    guestLogin: 'Kirish',
    profiles: 'Anketalar',
    profilesSub: 'Sherik tanlang',
    incoming: "Kiruvchi so'rovlar",
    outgoing: "Chiquvchi so'rovlar",
    adminChat: 'Support',
    groupChat: 'Savol-javob guruhi',
    partnerChat: 'Sherik bilan yozishma',
    noRequests: "Hozircha so'rovlar yo'q",
    noProfiles: "Hozircha anketalar yo'q",
    sendRequest: "So'rov yuborish",
    requestSent: "So'rov yuborildi",
    acceptRequest: 'Qabul qilish',
    rejectRequest: 'Rad etish',
    cancelRequest: "So'rovni bekor qilish",
    pending: 'Javob kutilmoqda',
    male: 'Erkak',
    female: 'Ayol',
    yearsOld: '{{age}} yosh',
    chatSoon: "Chat tez orada qo'shiladi",
    firstMessage: 'Birinchi xabarni yuboring!',
    messagePlaceholder: 'Xabar yozing...',
    endPartnership: 'Suhbatni tugatish',
    support: "Qo'llab-quvvatlash",
    adminMessagePlaceholder: 'Xabar yozing...',
    adminPrompt: 'Support bilan yozishmalar',
    cancelingRequest: 'Bekor qilinmoqda...',
    endConfirmBody: 'Sheriklik tugatilsa, chat yopiladi va qayta ulanish uchun yangi so‘rov kerak bo‘ladi.',
    endConfirmTitle: 'Suhbatni tugatishni tasdiqlang',
    ending: 'Tugatilmoqda...',
    formAbout: 'O‘zingiz haqingizda',
    formAboutPlaceholder: 'Qisqacha yozing...',
    formAge: 'Yosh',
    formAgePlaceholder: 'Masalan: 25',
    formCreateTitle: 'Anketa yaratish',
    formEditTitle: 'Anketani tahrirlash',
    formGender: 'Jins',
    formGoal: 'Maqsad',
    formLanguageLevel: 'Rus tili darajasi',
    formName: 'Ism',
    formNamePlaceholder: 'Ismingiz',
    formSelect: 'Tanlang',
    formSubtitle: 'Sherik topish uchun maʼlumotlaringizni kiriting',
    goalConversation: 'Suhbat',
    goalWork: 'Ish',
    groupFallback: 'Savol-javob guruhi',
    groupFirstQuestion: 'Birinchi savolingizni yozing',
    groupQuestionPlaceholder: 'Savol yozing...',
    incomingSub: 'Sizga kelgan so‘rovlar',
    later: 'Keyinroq',
    levelAdvanced: 'Ilg‘or',
    levelBeginner: 'Boshlang‘ich',
    levelElementary: 'Elementar',
    levelIntermediate: 'O‘rta',
    levelUpper: 'Yuqori-o‘rta',
    membersOnline: '{{members}} aʼzo · {{online}} onlayn',
    mentionAlert: 'Sizni belgilashdi',
    mentionEmpty: 'Hech kim topilmadi',
    mentionTitle: 'Kimni belgilaysiz?',
    noProfilesSub: 'Boshqa foydalanuvchilar anketasini yaratganda ular shu yerda ko‘rinadi',
    outgoingSub: 'Siz yuborgan so‘rovlar',
    partnerLabel: 'Sherik',
    typingMany: '{{first}}, {{second}} va boshqalar yozmoqda...',
    typingOne: '{{name}} yozmoqda...',
    typingTwo: '{{first}} va {{second}} yozmoqda...',
  },
  teachers: {
    videoTitle: 'Video-taqdimot',
    title: "O'qituvchilar",
    subtitle: "Tajribali o'qituvchilardan dars oling",
    details: 'Batafsil',
    emptyTitle: "Hozircha o'qituvchilar yo'q",
    emptyDesc: "Faol o'qituvchilar ro'yxatga qo'shilganda ular shu yerda ko'rinadi.",
    notFound: "O'qituvchi topilmadi",
    about: 'Men haqimda',
    reviews: "O'quvchilar fikri",
    experience: 'Tajriba:',
    price: 'Oylik kurs:',
    formatOnline: 'Onlayn',
    formatOffline: 'Oflayn',
    priceNegotiable: 'Narx kelishiladi',
    notSpecified: "Ko'rsatilmagan",
    student: "O'quvchi",
    trialBook: 'Sinov darsini band qilish',
    trialPending: "To'lov tekshirilmoqda",
    age: 'Yosh',
    lessonFormat: 'Dars formati',
    region: 'Hudud',
    reviewPlaceholder: 'Sharh',
    trialMessageHint: 'O‘qituvchiga xabar qoldiring (ixtiyoriy)',
    trialMessagePlaceholder: 'Salom! Sinov darsini band qilmoqchiman...',
    trialPayRub: 'Rubl bilan to‘lash',
    trialPayUzs: "So'm bilan to'lash",
    trialPaymentNavError: 'To‘lov sahifasiga o‘tib bo‘lmadi',
    trialPaymentPending: 'Sinov darsi uchun to‘lov allaqachon tekshirilmoqda',
    trialPendingBody: 'Admin tasdiqlagach siz bilan chat ochiladi va dars vaqti kelishiladi.',
    trialRahmatStartError: 'Rahmat to‘lovi boshlanmadi',
    trialRubHint: 'Rossiya kartasi orqali to‘lov',
    loginTitle: "O'qituvchi kirishi",
    cabinetLogin: 'Kabinetga kirish',
    loggingIn: 'Kirilmoqda...',
    identifierLabel: 'Email yoki telefon',
    loginError: 'Kirishda xatolik yuz berdi',
    searchPlaceholder: "Ism yoki hudud bo'yicha qidiring",
    resultsCount: '{{count}} ta o\'qituvchi',
    noResults: "Qidiruv bo'yicha o'qituvchi topilmadi",
    sortRelevance: 'Tavsiya',
    sortPriceLow: 'Arzon narx',
    sortPriceHigh: 'Qimmat narx',
    sortExperience: 'Tajribali',
    sortRating: 'Reyting',
    ratingNew: 'Yangi',
    reviewsCount: '{{count}} ta fikr',
  },
  courses: {
    title: 'Kurslar',
    patentTitle: 'Patent imtihoni',
    patentSubtitle: 'Patent imtihoniga tayyorlov kursi',
    vnzhTitle: 'ВНЖ imtihoni',
    vnzhSubtitle: 'ВНЖ imtihoniga tayyorlov kursi',
  },
  games: {
    title: "O'yinlar",
    howToPlay: 'Qanday o\'ynaladi',
    howToPlayText:
      "Qo'shni harflar bo'ylab barmoq yoki sichqoncha bilan chizing. To'g'ri ruscha so'z topilsa, pastdagi javob to'ldiriladi. Har bir katakdan bir marta foydalanish mumkin.",
    reset: 'Qayta boshlash',
    hint: 'Maslahat',
    stageProgress: 'Bosqich {{stage}} / {{total}}',
    levelLabel: '{{level}}-daraja',
    nextStage: 'Keyingi bosqich',
    availableStagesEnded: 'Hozircha ochiq bosqichlar tugadi',
    stageLocked: 'Bu bosqich hali ochilmagan',
    stageEmpty: 'Bu bosqichda hozircha so\'zlar yo\'q',
    gridGenerationFailed: 'Jadvalni yaratib bo\'lmadi',
    loginRequired: 'O\'ynash uchun tizimga kiring',
    loginToPlay: 'O\'ynash uchun kiring',
    saveProgressFailed: 'Progressni saqlab bo\'lmadi',
  },
  invite: {
    title: "Do'stlarni taklif qilish",
    subtitle: "Do'stlaringizni taklif qiling va bonus oling",
    statInvites: 'Takliflar',
    statRegistered: "Ro'yxatdan o'tgan",
    statPaid: "To'lov qilgan",
    statBalance: 'Bonus balans',
    linkMissing: 'Havola mavjud emas',
    listTitle: 'Takliflar roʻyxati',
    listEmpty: "Hozircha takliflar yo'q",
    statusPaid: "To'lov qildi",
    statusRegistered: "Ro'yxatdan o'tdi",
    statusInvited: 'Taklif yuborildi',
    bonusNote: 'Bonus balans avtomatik yangilanadi',
    shareText: "FalaRus kursiga qo'shiling",
  },
  help: {
    title: 'Yordam',
    admin: 'Admin',
    online: 'Onlayn',
    offline: 'Yopiq',
    noChats: "Hozircha yozishmalar yo'q",
    noMessages: "Hozircha xabarlar yo'q",
    placeholder: 'Muammo yoki savolingizni yozing...',
    image: 'Rasm',
    uploadError: 'Rasm yuklanmadi',
    messagesLoading: 'Xabarlar yuklanmoqda...',
  },
  notFound: {
    title: 'Sahifa topilmadi',
    body: "Manzil noto'g'ri yoki sahifa ko'chirilgan bo'lishi mumkin.",
    home: 'Bosh sahifa',
    login: 'Kirish',
    footerPatent: 'Patent kursi',
    footerVnzh: 'ВНЖ kursi',
    footerPricing: 'Tariflar',
    footerPrefix: 'Rus tili patent uchun va ВНЖ bo‘limlari:',
  },
  payment: {
    historyTitle: "To'lovlar tarixi",
    statusPending: 'Tekshirilmoqda',
    statusApproved: 'Tasdiqlandi',
    statusRejected: 'Rad etildi',
    empty: "Hozircha to'lovlar yo'q",
    popular: 'Eng mashhur',
    buyThreeMonth: '3 OY',
    buyYear: '1 YIL',
    currency: "so'm",
    acceptedBody: 'To‘lovingiz qabul qilindi.',
    acceptedDefault: 'Tasdiqlangandan so‘ng barcha darslar ochiladi.',
    acceptedTeacherTrial: 'Sinov darsi uchun admin tasdiqlashini kuting.',
    acceptedTitle: 'To‘lov qabul qilindi',
    back: 'Orqaga',
    backCabinet: 'Kabinetga qaytish',
    backProfile: 'Profilga qaytish',
    backTeacher: 'O‘qituvchilarga qaytish',
    buyThreeMonthAction: '3 oyni sotib olish',
    buyYearAction: '1 yilni sotib olish',
    cardCopy: 'Karta raqamini nusxalash',
    cardHolder: 'Karta egasi',
    cardNumber: 'Karta raqami',
    chooseAnotherFile: 'Boshqa fayl tanlash',
    contactAdmin: 'Admin bilan bog‘lanish',
    course: 'Kurs',
    fileSizeMax: 'Fayl hajmi 10 MB dan oshmasligi kerak',
    fileTypes: 'Faqat JPG, PNG, WEBP yoki PDF',
    nameCopy: 'Ismni nusxalash',
    needLogin: 'To‘lov uchun avval tizimga kiring',
    payExact: 'Aniq shu summani o‘tkazing',
    pendingDefault: 'To‘lovingiz administrator tomonidan tekshirilmoqda. Tasdiqlangach kirish ochiladi.',
    pendingTeacherListing: 'Ro‘yxat to‘lovi tekshirilmoqda. Tasdiqlangach profil faollashadi.',
    pendingTeacherTrial: 'Sinov darsi to‘lovi tekshirilmoqda.',
    pendingTitle: "To'lov tekshirilmoqda",
    phoneCopy: 'Telefon raqamini nusxalash',
    phoneNumber: 'Telefon raqami',
    rahmatStartError: 'Rahmat to‘lovini boshlashda xato',
    selectOrDrop: 'Faylni tanlang yoki bu yerga tashlang',
    service: 'Xizmat',
    submit: "To'lovni yuborish",
    submitting: 'Yuborilmoqda...',
    tariff: 'Tarif',
    teacherTrialRubHint: 'Sinov darsi narxi rublda ko‘rsatilgan',
    teacherTrialUzsHint: 'Sinov darsi: {{amount}} so‘m (Rahmat)',
    uploadFormats: 'JPG, PNG, WEBP yoki PDF, maks. 10 MB',
    uploadReceipt: 'Chek yoki skrinshot yuklang',
    uploaded: 'yuklandi',
    amountTitle: "To'lov summasi",
    currencyTitle: "To'lov valyutasini tanlang",
    currencySubtitle: "Qaysi valyutada to'lamoqchisiz?",
  },
  pricing: {
    pendingNotice: 'To‘lovingiz tekshirilmoqda. Tasdiqlangach Premium faollashadi.',
    alreadyActive: 'Premium allaqachon faol',
    loadError: 'Tariflar yuklanmadi',
    whyTitle: 'Nega aynan bu kurs?',
    ctaEnroll: 'Kursga yozilish',
    vocabTitle: "Lug'at — 3 bosqichda",
    benefitGrammar: '182 kunlik grammatika rejasi',
    benefitVocab: "Har kuni yangi so'zlar va mashqlar",
    benefitInteractive: 'Interaktiv topshiriqlar',
    benefitGames: 'O‘yinlar orqali o‘rganish',
    benefitStats: 'Statistika va ketma-ket kunlar',
    benefitLeaderboard: 'Reyting va motivatsiya',
    whySmartTitle: 'Aqlli reja',
    whySmartDesc: 'Har kun aniq vazifalar — chalkashliksiz o‘rganasiz',
    whyGameTitle: 'O‘yin formati',
    whyGameDesc: 'Qiziqarli mashqlar motivatsiyani saqlaydi',
    whyStatsTitle: 'Progress kuzatuvi',
    whyStatsDesc: 'Natijalaringizni ko‘ring va rivojlaning',
    whyLeaderboardTitle: 'Reyting',
    whyLeaderboardDesc: 'Boshqalar bilan raqobatlashing va g‘alaba qozoning',
    vocabStepLearnDesc: 'Kartochkalar orqali so‘zlarni tanishing',
    vocabStepTestDesc: 'Test orqali bilimingizni tekshiring',
    vocabStepPairsDesc: 'Rus va o‘zbek juftlarini toping',
  },
  rahmat: {
    title: 'To‘lov qabul qilindi',
    body: 'Agar kirish hali ochilmasa, bir necha soniyadan so‘ng profilni yangilang. Rahmat to‘lovi tasdiqlangach avtomatik yangilanadi.',
    goProfile: 'Profilga o‘tish',
    goHome: 'Bosh sahifa',
  },
  kunlik: {
    noQuestions: "Bu kun uchun savol yo'q",
    selectAnswer: "To'g'ri javobni tanlang",
    arrangeSentence: 'Gapni tuzing',
    clear: 'Tozalash',
    learnedWords: "O'rganilgan so'zlar:",
    stepLearn: 'Tanishish',
    stepTest: 'Test',
    stepPairs: 'Juftini topish',
    completed: 'Tugagan',
    daySpeaking: 'Kun {{day}} · Gapirish',
    seqHint2: 'Avval 1-vazifani tugating',
    seqHint3: 'Avval 2-vazifani tugating',
    noVocabRows: "Bu kun uchun lug'at bo'sh",
    knowDontKnow: 'Biladi: {{known}} · Bilmaydi: {{unknown}}',
    goToLearn: "Tanishishga o'tish",
    testLocked: 'Test qulflangan',
    step2LockedHint: 'Avval tanishish bosqichini tugating',
    step3LockedHint: 'Testdan kamida 80% bilan o‘ting',
    allPairsFound: 'Barcha juftlar topildi',
    ruUzPairs: 'Rus va o‘zbek juftlari',
    backToPlan: 'Kunlik rejaga qaytish',
    noMatchPairs: 'Juftliklar topilmadi',
    noReadingContent: 'Bu kun uchun o‘qish materiallari yo‘q',
    noSpeakingTasks: 'Bu kun uchun gapirish topshiriqlari yo‘q',
    noTasks: 'Bu kun uchun topshiriqlar yo‘q',
    passed: 'O‘tdi',
    readingDoneAlready: 'O‘qish allaqachon bajarilgan',
    readingFinishDelay: 'Yakunlash uchun {{seconds}} soniya o‘qing',
    sentenceTestSoon: 'Gap tuzish testi tez orada ({{count}} savol)',
    speakingDoneAlready: 'Gapirish bo‘limi bajarilgan',
    freeLimitTitle: 'Obuna kerak',
    freeLimitBody:
      'Kunlik kurs to‘liq obuna bilan ochiladi. To‘lovdan keyin 182 kunning hammasi ochiq bo‘ladi.',
    chooseTariff: 'Tarifni tanlash',
    continueCta: 'Davom etish uchun bosing',
    testHint: 'Kamida 80% bilan o‘ting',
    vocabWords: "So'zlar",
    invalidDay: 'Kun raqami noto‘g‘ri',
    wordsShapeInvalid: 'So‘zlar shakli noto‘g‘ri',
    pairsLockedTitle: 'Juftliklar qulflangan',
    pairsLockedHint: 'Keyingi bosqich ochilishi uchun kamida 80% to‘g‘ri javob kerak.',
    backToTest: 'Testga qaytish',
  },
  patent: {
    title: 'Patent imtihoni',
    paywallTitle: 'Kurs yopiq',
    paywallBuy: 'Sotib olish',
    resultsLoadError: 'Natijalar yuklanmadi',
    statusOpen: 'Ochiq',
    variantNotFound: 'Variant topilmadi',
    writeAnswerPlaceholder: 'Javobni yozing',
  },
  vnzh: {
    rahmatStartError: 'Rahmat to‘lovi boshlanmadi. Keyinroq urinib ko‘ring.',
    backAria: 'Orqaga',
    sectionNotFound: 'Bo‘lim topilmadi',
  },
  profile: {
    tapPhoto: 'Rasm uchun bosing',
    premiumDaysLeft: 'Premium · {{days}} kun qoldi',
    groups: {
      personal: 'Shaxsiy',
      settings: 'Sozlamalar',
      help: 'Yordam',
    },
    rows: {
      profile: 'Profil',
      certificates: 'Sertifikatlar',
      invite: "Do'stlarni taklif qilish",
      textSize: 'Matn hajmi',
      notifications: 'Bildirishnomalar',
      darkMode: 'Tungi rejim',
      language: 'Til',
      sound: 'Ovoz va tebranish',
      help: 'Yordam',
      pricing: 'Tariflar',
      paymentHistory: "To'lovlar tarixi",
      logout: 'Chiqish',
    },
    firstName: 'Ism',
    lastName: 'Familiya',
    save: 'Saqlash',
    cancel: 'Bekor',
    nameUpdated: 'Ism yangilandi',
    avatarUpdated: 'Profil rasmi yangilandi',
    avatarUploadFailed: 'Rasm yuklanmadi',
    nameRequired: "Ism va familiya to'ldirilishi kerak",
    edit: 'Tahrirlash',
    gender: 'Jins',
    genderMale: 'Erkak',
    genderFemale: 'Ayol',
    russianLevel: 'Rus tili darajasi',
    contactSecurity: 'Aloqa va xavfsizlik',
    currentPassword: 'Joriy parol',
    newPassword: 'Yangi parol',
    profileUpdated: 'Profil yangilandi',
    textSizeAria: 'Matn hajmi',
  },
  auth: {
    benefits: {
    },
    register: "Ro'yxatdan o'tish",
    logIn: 'Kirish',
    logInTitle: 'Kirish',
    createAccountTitle: "Ro'yxatdan o'tish",
    phone: 'Telefon',
    email: 'Email',
    password: 'Parol',
    createPassword: "Parol o'ylab toping",
    rewritePassword: 'Parolni qayta kiriting',
    name: 'Ism',
    surname: 'Familiya',
    emailHint: 'username@gmail.com',
    forgotPassword: 'Parolni unutdingizmi?',
    or: 'YOKI',
    continueWithGoogle: 'Google orqali davom etish',
    noAccount: 'Hisobingiz yo‘qmi? ',
    signUp: "Ro'yxatdan o'tish",
    haveAccount: 'Hisobingiz bormi? ',
    emailRequired: 'Email kiritilishi shart',
    emailInvalid: 'Email noto‘g‘ri',
    phoneInvalid: 'Telefon raqami noto‘g‘ri',
    passwordRequired: 'Parol kiritilishi shart',
    passwordMinLength: 'Parol kamida 6 belgidan iborat bo‘lishi kerak',
    passwordsMismatch: 'Parollar mos kelmaydi',
    nameRequired: 'Ism kiritilishi shart',
    surnameRequired: 'Familiya kiritilishi shart',
    termsPrefix: 'Hisob ochish orqali men ',
    termsOfUse: 'Foydalanish shartlari',
    termsAnd: ' va ',
    privacyPolicy: 'Maxfiylik siyosati',
    termsSuffix: 'ga roziman.',
    resetTitle: 'Parolni tiklash',
    resetSubtitle: 'Email manzilingizga yangi parol yuboramiz',
    resetSendPassword: 'Yangi parol yuborish',
    resetSuccessTitle: 'Email yuborildi',
    resetSuccessSubtitle: 'Agar hisob mavjud bo‘lsa, yangi parol email manzilingizga yuborildi',
    networkError: 'Internet bilan aloqa yo‘q. Iltimos, qayta urinib ko‘ring.',
    genericError: 'Xatolik yuz berdi',
    loginRequired: 'Kirish kerak',
  },
  liveStream: {
    badge: 'JONLI',
    title: 'Jonli efir',
    join: 'Efirga kirish',
    watchingHint: 'Gapirish uchun mikrofon, ko‘rinish uchun kamera tugmasini bosing',
    callTitle: 'Jonli efir boshlandi',
    callJoin: 'Qo‘shilish',
    callDecline: 'Keyinroq',
    pushAllow: 'Ruxsat',
    pushModalTitle: 'Efir boshlanganda qo‘ng‘iroq qilamiz',
    pushModalBody: 'Ruxsat bersangiz, jonli efir boshlangan zahoti telefoningizga xabar keladi — ilova yopiq bo‘lsa ham.',
    pushLater: 'Keyinroq',
    upcomingTitle: 'Yaqinlashayotgan efirlar',
    noneTitle: 'Hozir jonli efir yo‘q',
    noneSubtitle: 'Efir boshlanganda bosh sahifada va Suhbat bo‘limida xabar chiqadi',
    back: 'Ortga',
    loadError: 'Efir ma’lumoti yuklanmadi',
  },
};

export default uz;
